import {ReactNode} from "react"
import {backgroundColorMap, ColorType} from "common/helpers/color.helper"

export interface DialogBoxProps {
    show: boolean
    close: () => void
    children?: ReactNode
    title?: string
    color?: ColorType
}


export const AlertDialogBox = ({show, children, close, title, color = "danger"}: DialogBoxProps) => {
    const headerBackgroundColor = backgroundColorMap[color]
    const backGroundColor = backgroundColorMap["danger"]
    return (
        <div className={`modal `} style={{display: show ? "block" : "none", zIndex: 100000}}>
            <div className={`modal-background ${backGroundColor}`} style={{opacity: .2}}/>
            <div className="modal-card model-modal" style={{width: 300, maxHeight: 950}}>
                <header className={`modal-card-head ${headerBackgroundColor}`}>
                    <p className="modal-card-title has-text-white">{title}</p>
                </header>
                {children}
            </div>
        </div>
    )
}
